export default __webpack_public_path__ + "static/media/APIs-and-Microservices.bd87b7b8.png";